import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { isValidEmail } from '_core/helpers/validations';
import { IDocs } from '_core/types';
import { ErrorsFlowTypes } from '_core/types/Responses';
import { Bundle } from '_core/util';
import { recoverMemberNumberApi as API } from '../Apis';

export const RecoverMemberNumberDocs: IDocs = {
  title: 'RecoverMemberNumber',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.recoverMemberNumber',
};

const prepareCall = (stateRequestParameters: any) => {
  const config = Bundle.getValue('config');

  let request = {};
  if (isValidEmail(stateRequestParameters.login).isValid)
    request = {
      email: stateRequestParameters.login,
    };
  else
    request = {
      document: { type: 'CPF', value: stateRequestParameters.login },
    };

  return API.call.post({
    ...request,
    birthDate: stateRequestParameters.birthDate,
    recaptcha:
      config.service.environment === 'MOCK'
        ? undefined
        : { responseToken: stateRequestParameters?.tokenRecaptcha },
  });
};

const handleErrorFlowFinalResponseFunction = (infos: ErrorsFlowTypes) => {
  const smilesAccountNotFound =
    infos?.loginInvalid || infos?.userNotFound || infos?.wrongData;

  const smilesErrorService =
    infos?.errorService || infos?.processFailure || !smilesAccountNotFound;

  return { smilesAccountNotFound, smilesErrorService };
};

export const RecoverMemberNumberMachine = GenericMachine(
  prepareCall,
  {
    docs: RecoverMemberNumberDocs,
    definitions: API.definitions,
  },
  {
    handleErrorFlowFinalResponseFunction,
  },
);
